import { render, staticRenderFns } from "./cascadedFieldItem.vue?vue&type=template&id=4e0d4f44&scoped=true"
import script from "./cascadedFieldItem.vue?vue&type=script&lang=js"
export * from "./cascadedFieldItem.vue?vue&type=script&lang=js"
import style0 from "./cascadedFieldItem.vue?vue&type=style&index=0&id=4e0d4f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0d4f44",
  null
  
)

export default component.exports